import { css } from 'styled-components';
import token from 'styled-token';
import { fontColorMixin } from '../fontColorMixin';
import { inlineMediaQueryMixin } from '../inlineMediaQueryMixin';
import { mediaQueryMixin } from '../mediaQueryMixin';
import { spacingMixin } from '../spacingMixin';
var sizeCSS = inlineMediaQueryMixin('size', function (mediaProps) {
  return token('icons.sizes', function (iconSizes) {
    var size = mediaProps.size;
    if (iconSizes && iconSizes[size]) {
      var iconSize = iconSizes[size] + "px";
      return "\n                height: " + iconSize + ";\n                width: " + iconSize + ";\n            ";
    }
    return '';
  })(mediaProps);
});

/** @class IconMixin */
/** @method */
export var IconMixin = function IconMixin(props) {
  return css(["display:inline-block;vertical-align:top;stroke:currentColor;fill:currentColor;", " ", " height:1em;width:1em;", " ", ""], fontColorMixin(props), spacingMixin(props), sizeCSS(props), mediaQueryMixin(function (mediaProps) {
    return sizeCSS(Object.assign({}, props, mediaProps));
  }));
};